import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

import { Store } from '@ngrx/store';
import { AgencyConfigInfoUpdate } from 'src/app/features/agency-config/model/agencyConfig.model';
import { injectConfigs } from '../config/utils';
import { DomainService } from '../services/domain-config.service';
import * as AgencyConfigActions from '../states/agencyConfig/agencyConfig.action';
import { agency } from '../states/shared/shared.selector';

@Injectable({
  providedIn: 'root',
})
export class AgencyConfigService {
  _http = inject(HttpClient);
  endpoint = injectConfigs().endPoints.AGENCY_API_URL;
  _store = inject(Store);
  _domainService = inject(DomainService);
  tenant = this._domainService.tenant();

  getAgencyConfig(): Observable<any> {
    return this._store.select(agency).pipe(
      switchMap((agency) => {
        return this._http.get<any>(
          this.endpoint +
            `/gateway/agency/detail-admin?Agency=${
              agency ? agency : localStorage.getItem('agency')
            }`
        );
      })
    );
  }
  getAgencyAdminConfig(): Observable<any> {
    return this._http
      .get<any>(this.endpoint + `/gateway/agency/detail?Agency=${this.tenant}`)
      .pipe(
        switchMap((data: any) => {
          this._store.dispatch(
            AgencyConfigActions.getAgencyConfigSuccess2({ pro: data })
          );
          return of(data);
        })
      );
  }

  updateAgencyConfig(body: AgencyConfigInfoUpdate): Observable<any> {
    return this._http.patch<any>(
      this.endpoint + '/gateway/agency/admin-agency/update',
      body
    );
  }

  createAgencyConfig(body: AgencyConfigInfoUpdate): Observable<any> {
    return this._http.post<any>(this.endpoint + '/gateway/agency/create', body);
  }
}
